import { PriceManagerDatapointsModel } from '../../hooks/usePriceManagerDatapointsModel';
import { getVariationPrices } from '../../services';

export const variationPriceQuery = (priceManagerDatapointsModel?: PriceManagerDatapointsModel) => {
  return {
    queryKey: ['variationPrice', priceManagerDatapointsModel],
    queryFn: () => getVariationPrices(priceManagerDatapointsModel),
  };
};
